export default {
  1: { countryCode: 1, dialCode: '1', maxLength: 10 },
  2: { countryCode: 1, dialCode: '1', maxLength: 10 },
  4: { countryCode: 4, dialCode: '44', maxLength: 15 },
};
